import React, { memo } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import cc from 'classcat';
import { Route, Switch } from 'react-router-dom';
import { applyContainerQuery } from 'lib/react-container-query';
import User from 'modules/User';
import ThemeLogo from 'components/ThemeLogo';
import RouterLink from 'components/RouterLink';
import './publicNavbar.css';

const query = {
  'max-height-48': { maxHeight: 48 }
};

export const _PublicNavbar = ({ containerQuery, search, isReturningPlayer, inverted }) => (
  <div className={cc(['publicNavbar', containerQuery, { 'publicNavbar--inverted': inverted }])}>
    <header className="publicNavbar__header">
      <section className="publicNavbar__logoContainer">
        <Switch>
          <Route path={['/signup/personal-info', '/signup/confirmation']}>
            <ThemeLogo inverted={inverted} />
          </Route>
          <Route>
            <RouterLink href="/" title="Back Home" target="_self">
              <ThemeLogo inverted={inverted} />
            </RouterLink>
          </Route>
        </Switch>
      </section>
      {!isReturningPlayer && (
        <Switch>
          <Route path="/login">
            <RouterLink className="publicNavbar__link" href={`/signup/account-details${search}`}>
              Sign up
            </RouterLink>
          </Route>
          <Route path="/reset-password">
            <RouterLink className="publicNavbar__link" href={`/login${search}`}>
              Login
            </RouterLink>
          </Route>
        </Switch>
      )}
    </header>
  </div>
);

const mapStateToProps = (state) => ({
  isReturningPlayer: Boolean(User.selectors.getReturningPlayer(state))
});

export default compose(memo, connect(mapStateToProps), applyContainerQuery)(_PublicNavbar, query);
